import React, { useContext, useEffect, useRef, useState } from 'react'
import DesktopNav from './DesktopNav'
import MobileNav from './MobileNav'
import TopNav from './TopNav'

const MegaMenu = () => {
  const [mobileActive, setMobileActive] = useState(false)

  return (
    <div className='fixed top-0 bg-white z-[50] w-full'>
      <div className='mega-menu-wrapper'>
        <TopNav mobileActive={mobileActive} onUpdate={setMobileActive} />
        <DesktopNav />
        <MobileNav mobileActive={mobileActive} />
      </div>
    </div>
  )
}

export default MegaMenu
